(function () {
  const CUSTOMER_POSTED_PARAM = 'customer_posted';

  function showFormSuccess(form) {
    const fieldGroup = form.querySelector('.mmx-password__field-group');
    const submitButton = form.querySelector('.mmx-password__button');
    const successMessage = form.querySelector('[data-success-message]');

    if (fieldGroup) fieldGroup.hidden = true;
    if (submitButton) submitButton.hidden = true;
    if (successMessage) successMessage.hidden = false;
  }

  function initPasswordForm(form) {
    const params = new URLSearchParams(window.location.search);

    if (params.get(CUSTOMER_POSTED_PARAM) === 'true' || form.querySelector('[data-success-message]:not([hidden])')) {
      showFormSuccess(form);
    }
  }

  document.querySelectorAll('.mmx-password__form').forEach(initPasswordForm);
})();
